import { useState } from "react";
import { api } from "@/lib/api";
import { useData } from "@/lib/data";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserPlus, Check, X } from "lucide-react";
import { toast } from "sonner";

export default function CustomerPicker({ value, onChange }) {
  const { customers, refreshCustomers } = useData();
  const [creating, setCreating] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [contact, setContact] = useState("");
  const [cargo, setCargo] = useState("");
  const [saving, setSaving] = useState(false);

  const create = async () => {
    if (!name.trim()) { toast.error("Müşteri adı zorunlu"); return; }
    setSaving(true);
    try {
      const r = await api.post("/customers", { name: name.trim(), phone, contact_name: contact, cargo_company: cargo });
      await refreshCustomers();
      onChange(r.data.id);
      toast.success("Müşteri oluşturuldu");
      setCreating(false); setName(""); setPhone(""); setContact(""); setCargo("");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
    finally { setSaving(false); }
  };

  if (creating) {
    return (
      <div className="rounded-md border border-[#D97706]/50 bg-[#EFE6D6] p-3 space-y-2" data-testid="quick-customer-form">
        <Label className="text-xs text-[#B45309] uppercase tracking-widest">Yeni Müşteri</Label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <Input data-testid="quick-customer-name" placeholder="Müşteri adı *" value={name}
            onChange={(e) => setName(e.target.value)} className="h-10 bg-[#FFFBF4] border-[#DCCFB8]" />
          <Input data-testid="quick-customer-contact" placeholder="Yetkili adı soyadı" value={contact}
            onChange={(e) => setContact(e.target.value)} className="h-10 bg-[#FFFBF4] border-[#DCCFB8]" />
          <Input data-testid="quick-customer-cargo" placeholder="Kargo firması" value={cargo} list="cargo-companies-quick"
            onChange={(e) => setCargo(e.target.value)} className="h-10 bg-[#FFFBF4] border-[#DCCFB8]" />
          <datalist id="cargo-companies-quick">
            {["Yurtiçi Kargo", "Aras Kargo", "MNG Kargo", "PTT Kargo", "Sürat Kargo", "UPS", "DHL", "Ambar"].map((k) => <option key={k} value={k} />)}
          </datalist>
          <Input data-testid="quick-customer-phone" placeholder="Telefon" value={phone}
            onChange={(e) => setPhone(e.target.value)} className="h-10 bg-[#FFFBF4] border-[#DCCFB8]" />
        </div>
        <div className="flex gap-2 justify-end">
          <Button type="button" variant="outline" onClick={() => setCreating(false)} data-testid="quick-customer-cancel"
            className="h-9 border-[#DCCFB8] bg-transparent text-[#6B5B4A] hover:bg-[#FFFBF4] hover:text-[#2B2118]">
            <X className="w-4 h-4 mr-1" /> Vazgeç
          </Button>
          <Button type="button" onClick={create} disabled={saving} data-testid="quick-customer-save"
            className="h-9 bg-[#D97706] hover:bg-[#B45309] text-white">
            <Check className="w-4 h-4 mr-1" /> {saving ? "Kaydediliyor" : "Kaydet ve Seç"}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid="order-customer-select" className="h-11 bg-[#EFE6D6] border-[#DCCFB8] flex-1">
          <SelectValue placeholder="Müşteri kartı seçin..." />
        </SelectTrigger>
        <SelectContent className="bg-[#EFE6D6] border-[#DCCFB8] text-[#2B2118]">
          {customers.length === 0 && <div className="px-3 py-2 text-sm text-[#8C7B68]">Müşteri yok</div>}
          {customers.map((c) => (
            <SelectItem key={c.id} value={c.id} data-testid={`order-customer-option-${c.id}`}>
              {c.name}{c.phone ? ` · ${c.phone}` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button type="button" variant="outline" onClick={() => setCreating(true)} data-testid="order-new-customer-btn"
        className="h-11 border-[#DCCFB8] bg-[#EFE6D6] text-[#B45309] hover:bg-[#FFFBF4] hover:text-[#B45309]">
        <UserPlus className="w-4 h-4 mr-1" /> Müşteri Oluştur
      </Button>
    </div>
  );
}
